import type {
  InPersonBucketGroupCoverageEntry,
  OnlinePartnerBucketGroups,
} from "./partner.interface";
import type {
  OnlineBucketGroupCoverageEntry,
  OnlinePricingStructure,
} from "./onlinePricing.interface";

export type IPartnerDeal = IMerchantDetails & {
  _id: string;
  partnerId: string;
  partnerName?: string;
  purchPriceProfileId: string;
  onlinePurchPriceProfileId?: string;
  bucketGroups: PartnerBucketGroups;
  // Priced in whichever shape the partner is on: the four online buckets for a
  // legacy partner, or every group the partner's card split and local method
  // carry for a 16-bucket one, which the create rejects if any is missing.
  onlineBucketGroups?: OnlinePartnerBucketGroups;
  onlinePricingTemplate?: OnlinePricingTemplate;
  onlinePricingStructure?: OnlinePricingStructure;
  onlineBucketGroupCoverage?: OnlineBucketGroupCoverageEntry[];
  inPersonBucketGroupCoverage?: InPersonBucketGroupCoverageEntry[];
  createdAt: string;
  isUsed?: boolean;
  usedOn?: string;
  key?: string;
};

export type IMerchantDetails = {
  businessName: string;
  businessRegistrationNumber: string;
};

export type PartnerBucketGroups = {
  domesticDebitCards: PartnerBucketGroupPrice;
  domesticCreditCards?: PartnerBucketGroupPrice;
  europeanDebitCards?: PartnerBucketGroupPrice;
  european: PartnerBucketGroupPrice;
  internationalAndCommercial: PartnerBucketGroupPrice;
  amex?: PartnerBucketGroupPrice;
};

export type PartnerBucketGroupPrice = {
  value: number;
  valueType: "Fixed" | "Percentage";
  min?: number;
  max?: number;
  // Preview only: the partner band's unit. Do not render the band with `valueType`.
  bandValueType?: "Fixed" | "Percentage";
};

export type ValueType = "Fixed" | "Percentage";

export type { OnlinePartnerBucketGroups } from "./partner.interface";

export enum OnlinePricingTemplate {
  Default = "default",
  BancontactBE = "bancontactBE",
  CardsOnly = "cardsOnly",
}

export type OnlineBucketFieldNames = keyof OnlinePartnerBucketGroups;
